// @flow
import * as React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import {
  getFeatures,
  updateFeature,
  getFeature,
} from 'src/redux/actions/featureManagement/featureManagement'

const withFeatureManagement = <P>(WrappedComponent: React.ComponentType<P>) => {
  class WithFeatureManagementComponent extends React.Component<P> {
    render() {
      return <WrappedComponent {...this.props} />
    }
  }
  const mapStateToProps = ({ featureManagement }) => ({ featureManagement })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    getFeatures: data => dispatch(getFeatures.request(data)),
    updateFeature: data => dispatch(updateFeature.request(data)),
    getFeature: data => dispatch(getFeature.request(data)),
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withRouter(WithFeatureManagementComponent))
}

export default withFeatureManagement

